
var font = {
  "0": "M186 1065h654q114 0 195.5 -81.5t81.5 -195.5v-776q0 -116 -81.5 -197t-195.5 -81h-369q-115 0 -197 81t-82 197v776q0 52 19 100t19 82q0 24 -11 47.5t-21 35.5zM480 95q0 -31 21.5 -52.5t52.5 -21.5h203q31 0 52.5 21.5t21.5 52.5v610q0 29 -21.5 51.5t-52.5 22.5h-203 q-31 0 -52.5 -22.5t-21.5 -51.5v-610z",
  "1": "M174 1065h342v-1331h-286v1197q0 43 -13.5 76.5t-28.5 45.5z",
  "2": "M174 1065h702q115 0 196 -81.5t81 -195.5v-255q0 -114 -81 -195.5t-196 -81.5h-286q-31 0 -52.5 -21.5t-21.5 -52.5v-161h637v-287h-924v531q0 115 81 196t197 81h286q30 0 52 22t22 52v89q0 29 -22 51.5t-52 22.5h-564v152q0 43 -13.5 76.5t-28.5 45.5z",
  "3": "M174 1065h702q115 0 196 -81.5t81 -195.5v-172q0 -58 -20.5 -104.5t-45.5 -68.5t-46 -32l-21 -12q8 -3 22.5 -11t43 -31.5t48 -70t19.5 -104.5v-170q0 -116 -81 -197t-196 -81h-647v287h564q30 0 52 21.5t22 52.5v87q0 31 -22 52.5t-52 21.5h-564v286h564q30 0 52 22 t22 52v89q0 29 -22 51.5t-52 22.5h-564v152q0 43 -13.5 76.5t-28.5 45.5z",
  "4": "M161 399l126 532q11 43 0 76t-27 46l-16 12h279q33 0 55.5 -27t14.5 -62l-137 -577h323v666h287v-1331h-287v379h-390q-146 0 -201 84t-27 202z",
  "5": "M174 1065h979v-286h-637v-189h360q115 0 196 -81t81 -196v-301q0 -116 -81 -197t-196 -81h-647v287h564q30 0 52 21.5t22 52.5v135q0 30 -22 51.5t-52 21.5h-564v628q0 43 -13.5 76.5t-28.5 45.5z",
  "6": "M186 1065h877v-286h-509q-31 0 -52.5 -22.5t-21.5 -51.5v-115h360q114 0 195.5 -81t81.5 -196v-301q0 -116 -81.5 -197t-195.5 -81h-369q-115 0 -197 81t-82 197v776q0 52 19 100t19 82q0 24 -11 47.5t-21 35.5zM480 95q0 -31 21.5 -52.5t52.5 -21.5h203q31 0 52.5 21.5 t21.5 52.5v135q0 30 -21.5 51.5t-52.5 21.5h-203q-31 0 -52.5 -21.5t-21.5 -51.5v-135z",
  "7": "M159 1065h837q60 0 101.5 -41.5t41.5 -101.5q0 -25 -8 -48l-407 -1140h-305l373 1045h-578v152q0 43 -13.5 76.5t-27.5 45.5z",
  "8": "M186 1065h654q114 0 195.5 -81.5t81.5 -195.5v-158q0 -58 -21 -104t-45.5 -68t-45.5 -34l-21 -11q8 -2 22 -10.5t43 -32t48.5 -69.5t19.5 -105v-184q0 -116 -81.5 -197t-195.5 -81h-369q-115 0 -197 81t-82 197v184q0 59 21 105.5t46.5 69t46.5 32.5l20 10q-5 2 -14 6.5 t-32.5 21.5t-41 39.5t-32 62t-14.5 87.5v158q0 52 19 100t19 82q0 24 -11 47.5t-21 35.5zM480 95q0 -31 21.5 -52.5t52.5 -21.5h203q31 0 52.5 21.5t21.5 52.5v101q0 32 -21.5 53t-52.5 21h-203q-31 0 -52.5 -21t-21.5 -53v-101zM480 630q0 -29 21.5 -51.5t52.5 -22.5h203 q31 0 52.5 22.5t21.5 51.5v75q0 29 -21.5 51.5t-52.5 22.5h-203q-31 0 -52.5 -22.5t-21.5 -51.5v-75z",
  "9": "M185 1065h653q116 0 196.5 -81.5t80.5 -195.5v-776q0 -116 -81 -197t-196 -81h-592v287h509q30 0 52 21.5t22 52.5v114h-360q-115 0 -196.5 81.5t-81.5 195.5v302q0 52 19 100t19 82q0 24 -11 47.5t-23 35.5zM478 569q0 -31 21.5 -52.5t52.5 -21.5h203q30 0 52 21.5 t22 52.5v136q0 29 -22 51.5t-52 22.5h-203q-31 0 -52.5 -22.5t-21.5 -51.5v-136z",
  "A": "M140 -266l296 1331h246l294 -1331h-204l-62 319h-303l-63 -319h-204zM443 240h230l-114 588z",
  "B": "M195 -266v1331h437q76 0 131.5 -54.5t55.5 -132.5v-250q0 -59 -32.5 -105.5t-84.5 -68.5q52 -21 84.5 -68t32.5 -105v-360q0 -77 -55.5 -132t-131.5 -55h-437zM394 -79h183q17 0 29.5 12t12.5 29v356q0 17 -12 29.5t-30 12.5h-183v-439zM394 547h183q17 0 29.5 12.5 t12.5 29.5v247q0 17 -12 29.5t-30 12.5h-183v-331z",
  "C": "M187 -79v957q0 78 54.5 132.5t132.5 54.5h286v-187h-232q-17 0 -29.5 -12.5t-12.5 -29.5v-874q0 -17 12.5 -29t29.5 -12h234v-187h-288q-78 0 -132.5 55t-54.5 132z",
  "D": "M195 -266v1331h437q76 0 131.5 -54.5t55.5 -132.5v-957q0 -77 -55.5 -132t-131.5 -55h-437zM394 -79h183q17 0 29.5 12t12.5 29v874q0 17 -12 29.5t-30 12.5h-183v-957z",
  "E": "M195 -266v1331h475v-187h-276v-331h276v-187h-276v-439h276v-187h-475z",
  "F": "M195 -266v1331h475v-187h-276v-331h276v-187h-276v-626h-199z",
  "G": "M185 -79v832q0 130 91.5 221t220.5 91h113q109 0 199 -57v-197q-87 67 -199 67h-113q-46 0 -79 -33.5t-33 -78.5v-804q0 -17 12.5 -29t28.5 -12h142q17 0 29.5 12t12.5 29v398h-84v187h283v-626q0 -77 -55 -132t-133 -55h-249q-77 0 -132 55t-55 132z",
  "H": "M195 -266v1331h199v-518h225v518h200v-1331h-200v626h-225v-626h-199z",
  "I": "M195 -266v1331h200v-1331h-200z",
  "J": "M159 -49q53 -30 111 -30q24 0 41 16.5t17 39.5v1088h198v-1131q0 -84 -58 -142t-140 -58q-91 0 -169 37v180z",
  "K": "M195 -266v1331h200v-492l276 492h229l-323 -576l358 -755h-221l-319 673v-673h-200z",
  "L": "M195 -266v1331h199v-1144h276v-187h-475z",
  "M": "M195 -266v1331h250l274 -966l275 966h249v-1331h-199v846l-241 -846h-167l-241 846v-846h-200z",
  "N": "M195 -266v1331h247l277 -811v811h200v-1331h-247l-277 811v-811h-200z",
  "O": "M187 -79v957q0 78 55.5 132.5t131.5 54.5h250q78 0 132.5 -54.5t54.5 -132.5v-957q0 -77 -54.5 -132t-132.5 -55h-250q-76 0 -131.5 55t-55.5 132zM387 -38q0 -17 12.5 -29t29.5 -12h142q17 0 29 12t12 29v874q0 17 -12 29.5t-29 12.5h-142q-18 0 -30 -12.5t-12 -29.5 v-874z",
  "P": "M195 -266v1331h437q76 0 131.5 -54.5t55.5 -132.5v-416q0 -77 -55.5 -132.5t-131.5 -55.5h-238v-540h-199zM394 462h183q17 0 29.5 12t12.5 29v333q0 17 -12 29.5t-30 12.5h-183v-416z",
  "Q": "M188 -79v957q0 78 55.5 132.5t132.5 54.5h251q76 0 131.5 -54.5t55.5 -132.5v-957q0 -39 -17 -77l88 -127l-126 -134l-84 156q-21 -5 -48 -5h-251q-77 0 -132.5 54.5t-55.5 132.5zM389 -38q0 -17 12 -29t29 -12h142q18 0 30 12t12 29v874q0 17 -12 29.5t-30 12.5h-142 q-17 0 -29 -12.5t-12 -29.5v-874z",
  "R": "M195 -266v1331h437q76 0 131.5 -54.5t55.5 -132.5v-250q0 -59 -32.5 -105.5t-84.5 -68.5q52 -21 84.5 -68t32.5 -105v-547h-200v584q0 17 -12 29.5t-30 12.5h-183v-626h-199zM394 547h183q17 0 29.5 12.5t12.5 29.5v247q0 17 -12 29.5t-30 12.5h-183v-331z",
  "S": "M192 -79h383q17 0 29 12t12 29v356q0 17 -11.5 29.5t-29.5 12.5h-195q-78 0 -133 55.5t-55 131.5v331q0 78 55 132.5t133 54.5h436v-187h-383q-17 0 -29.5 -12.5t-12.5 -29.5v-247q0 -17 12.5 -29.5t29.5 -12.5h196q77 0 132 -54.5t55 -132.5v-439q0 -77 -55 -132 t-132 -55h-437v187z",
  "T": "M177 878v187h624v-187h-212v-1144h-200v1144h-212z",
  "U": "M191 -79v1144h200v-1103q0 -17 12.5 -29t29.5 -12h142q17 0 29 12t12 29v1103h200v-1144q0 -77 -55 -132t-132 -55h-249q-78 0 -133.5 55t-55.5 132z",
  "V": "M168 1065h204l191 -975l190 975h204l-261 -1331h-267z",
  "W": "M170 1065h202l134 -800l132 800h203l133 -800l132 800h203l-221 -1331h-229l-119 724l-121 -724h-228z",
  "X": "M185 -266l257 665l-257 666h214l150 -388l150 388h214l-257 -666l257 -665h-214l-150 388l-150 -388h-214z",
  "Y": "M161 1065h211l165 -506l166 506h210l-276 -844v-487h-200v487z",
  "Z": "M194 -266l364 1144h-364v187h624l-366 -1144h366v-187h-624z"
};
var font_size = 20,
panel_Hor_Adjustment = 0,
font_Top_Adjustment = -13,
tracking = 3,
small_Caps_Adjustment = {
  vertical: -165,
  horizontal: 0,
  scale_width: 0,
  scale_height: 0,
},
// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
colors = {
  characters: {
    home: [
              "#FFFFFF", // white
            ],
            away: [
              "#0A0203", // black
            ]
          },
          numbers: {
            home: [
              "#FFFFFF", // white
              "#B79257", // black
              '#231F20' // orange
            ],
            away: [
              "#D34D2A", // black
              "#B79257", // white
              '#231F20' // orange
            ]
          }
        },
        outlines = {
          characters: {
            width: 1.4
          },
          numbers: {
            width: 3
          }
        },
        special_Character_Adjustments = {
          period: {
          vertical: 0, // this moves it up from the bottom
          horizontal: 1,
          scale_width: 15.5,
          scale_height: 15.5,
        },
        hyphen: {
          vertical: -6,
          horizontal: -5.5,
          scale_width: 0,
          scale_height: -3,
        },
        apostrophe: {
          vertical: 0.25, // this is backwards
          horizontal: -1,
          scale_width: 0,
          scale_height: 0,
        }
      },
      number_Adjustments = {
        top: 11.5,
        left: -6,
        width: 71,
        height: 67,
        middle_Space: 6,
        oneOffset: 7
      };